import { RouteObject } from "react-router"
import { FornecedorList } from "./forn.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { LocalShipping } from "@mui/icons-material"

export enum PathRotaFornecedor {
    fornecedor = "/fornecedor"
}

const routerFornecedor: RouteObject = {
    path: PathRotaFornecedor.fornecedor,
    element: <FornecedorList/>,
}


export const navigationToFornecedorView = ()=> rotas.navigate(PathRotaFornecedor.fornecedor)

export function startRouterFornecedor(){
    const menu:MainMenu = {
        text:"Fornecedores",
        icon:<LocalShipping />,
        eventOnClick:navigationToFornecedorView
    }
    menuRotas.push(menu);
    return routerFornecedor
}